<template>


    <div v-if="isShowComment" class="col-12" style="padding-left:0;padding-right:0">
        <div id="questions" role="tabpanel" class="tab-pane form-comment">
            <article id="questionsContainer">
                <h2 class="param-title">
                    نظرات کاربران
                    <span v-if=" isUserLogined">نظر خود را مطرح نمایید</span>
                </h2>
                <div v-if=" isUserLogined">
                    <form @submit.prevent="submitReview" class="questionForm">
                        <div class="col-lg-12 col-md-12 col-xs-12">
                            <div class="form-group" style="text-align:right">
                                <label>متن نظر<span class="required">*</span></label>
                                <textarea v-model="newReview.Question"
                                          v-validate="'required'"
                                          name="question"
                                          data-vv-as="متن نظر"
                                          placeholder="نظر خود را مطرح نمایید"
                                          rows="3"
                                          class="form-control">
            </textarea>
                                <span v-if="errors.has('question')" class="error-text">{{ errors.first('question') }}</span>
                            </div>
                        </div>

                        <center>
                            <div class="chaptcha-div">
                                <img @click="refreshCaptcha"
                                     :src="captchaUrl"
                                     class="img-responsive"
                                     title="جهت عوض کردن عکس روی این عکس کلیک کنید" />
                                <input v-model="newReview.CaptchText"
                                       type="text"
                                       class="form-control"
                                       placeholder="متن تصویر را وارد کنید"
                                       v-validate="'required'"
                                       name="captchaText"
                                       data-vv-as="کپچا" />
                                <span style="text-align:center" v-if="errors.has('captchaText')" class="error-text">{{ errors.first('captchaText') }}</span>
                            </div>

                            <div class="parent-btn">
                                <button type="submit" class="dk-btn dk-btn-info">ثبت نظر</button>
                            </div>
                        </center>
                    </form>

                </div>
                <div v-else class="empty-blogReview">
                    <p>جهت ثبت نظر خود به سیستم وارد شوید.</p>
                    <router-link to="/login" class="btn default-btn">
                        ورود
                    </router-link>
                </div>
                <hr v-if="reviews.length > 0">
                <h2 class="param-title" v-if="reviews.length > 0">پرسش کاربران</h2>
                <div class="row" v-if="loading">
                    <div class="loader">
                        <img src="/assets/img/loader.jpg" />
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12" v-for="review in reviews" :key="review.Id">
                        <div class="j-qustion-content">
                            <div class="row">
                                <div class="managment-j col-md-2">
                                    <img src="/assets/img/svg/user.svg">
                                    <span class="title">{{ review.IsAnswered ? 'پاسخ توسط مدیر' : 'در انتظار پاسخ' }}</span>
                                </div>
                                <div class="col-md-10">
                                    <div class="j-qustion-answer">
                                        <span class="title-t">نظر {{ review.UserFullName}}</span>
                                        <span class="title-date-all">({{ review.RegDateTime }})</span>
                                        <p>{{ review.Question }}</p>
                                    </div>
                                    <div v-if="review.IsAnswered" class="j-qustion">
                                        <hr>
                                        <span class="title-t">پاسخ</span>
                                        <div class="title-date-all">
                                            <span>مدیر</span>
                                            <span>({{ review.AnsweredDateTime }})</span>
                                        </div>
                                        <p>{{ review.Answer	 }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            </article>
        </div>
    </div>


</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                isUserLogined: false,
                isShowComment: false,
                reviews: [],
                captchaText: "",
                newReview: {
                    Question: "",
                    captchaText: ""
                },
                captchaUrl: "/api/Captcha/",
                loader: true
            };
        },
        methods: {
            fetchReviews() {
            
                httpPromise(this, '/v1/ContentManagement/Comments/Read', 'post', { GroupId: this.$route.query.GroupId, SubGroupId: this.$route.query.SubGroupId  },
                    response => {

                        this.reviews = response.data.Value.FilteredReviews;
                        this.loader = false;

                    },
                    response => {
                        toastr.error(response.data.Message);
                        this.loader = false;
                    });
            },
            submitReview() {
                toastr.remove();
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        toastr.error("لطفاً خطاهای فرم را برطرف کنید.");
                        return;
                    }

                    // بررسی کپچا
                    if (this.newReview.CaptchText !== this.captchaText) {
                        toastr.error("متن تصویر وارد شده اشتباه است.");
                        return;
                    }
                    
                    this.loader = true;
                    if (!IsNullOrEmptyString(this.$route.query.SubGroupId)) {
                        this.newReview.SubGroupId = this.$route.query.SubGroupId;
                    }

                    if (!IsNullOrEmptyString(this.$route.query.GroupId)) {
                        this.newReview.GroupId = this.$route.query.GroupId;
                    }
                    httpPromise(this, '/v1/ContentManagement/Comments/Add', 'post', JSON.stringify(this.newReview),
                        response => {
                            toastr.success(response.data.Message);
                            this.newReview = {};
                            this.refreshCaptcha();
                        },
                        response => {
                            toastr.error(response.data.Message);
                            this.refreshCaptcha();
                        }
                    );
                });
            },
            refreshCaptcha() {
                httpPromise(this, '/Captcha/Get', 'get_2', '',
                    response => {
                        this.captchaText = response.data.Value.captchaText;
                        this.captchaUrl = response.data.Value.image;
                    },
                    response => {
                        console.error("خطا در دریافت کپچا", error);
                    }
                );
            }
        },
        mounted() {
            if (!IsNullOrEmptyString(this.$route.query.SubGroupId)) {
                this.isShowComment = true;
            }

            if (!IsNullOrEmptyString(this.$route.query.GroupId)) {
                this.isShowComment = true;

            }
            this.fetchReviews();
            this.refreshCaptcha();
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        watch: {
            $route: function (to, from) {
                const groupIdChanged = this.$route.query.GroupId !== from.query.GroupId;
                const subGroupIdChanged = this.$route.query.SubGroupId !== from.query.SubGroupId;

              
                if (groupIdChanged || subGroupIdChanged) {
                    this.isShowComment = true;
                    this.fetchReviews();
                }
            }
        }
    };
</script>

<style scoped>
    .managment-j {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

        .managment-j .title {
            margin-top: 10px;
            font-size: 17px;
            font-weight: 700;
        }

    .j-qustion-answer {
        text-align: right;
        white-space: pre-wrap;
    }

    .title-t {
        font-weight: 700;
        font-size: 17px;
    }

    .title-date-all {
        color: #c49595;
    }

    .j-qustion-answer p, .j-qustion p {
        white-space: pre-wrap;
        color: #777;
    }

    .error-text {
        color: red;
        font-size: 12px;
        display: block;
        margin-top: 5px;
        text-align: right;
    }

    #questions {
        padding: 10px;
        background-color: #fff;
        border-radius: 8px;
        margin: 20px 0;
    }

    .loader {
        position: absolute;
        background-color: rgba(128, 128, 128, 0.2);
        inset: 0px;
        z-index: 9999;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .chaptcha-div, .chaptcha-div img {
        margin-bottom: 7px;
    }

        .chaptcha-div input {
            width: 200px;
            text-align: center;
        }
</style>
